module.exports = __webpack_public_path__ + "static/img/75a3.f307fbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/75a3.jpg
// module id = hrvZ
// module chunks = 1